<template>
    <div class="product-show-box" flex="cross:center main:center" v-if="product" @click="$parent.showProductDialog = false">
        <div class="product-box-main">
            <div class="swiper-product" @click.stop="">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(c,i) in images" :key="i">
                        <div class="title">{{$lang.getLang() == 'cn' ? product.name : product.name_en}}</div>
                        <img :src="$util.img(c)" />
                    </div>
                </div>
            </div>
            <div class="swiper-pagination-1"></div>
            <div class="swiper-button-prev" @click.stop="">
                <img src="@/assets/image2/prev-btn.png" />
            </div>
            <div class="swiper-button-next" @click.stop="">
                <img src="@/assets/image2/next-btn.png" />
            </div>
            <div class="close">
                <img src="@/assets/image2/close.png" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            default: null
        },
        currentImageKey: {
            type: Number,
            default: 0
        }
    },
    computed: {
        images(){
            if(!this.product){
                return []
            }
            if(!this.product.images){
                return []
            }
            return JSON.parse(this.product.images)
        }
    },
    mounted(){
        var mySwiper1 = new Swiper ('.swiper-product', {
            // direction: 'vertical', // 垂直切换选项
            loop: true, // 循环模式选项
            autoplay: true,
            
            // 如果需要分页器
            pagination: {
                el: '.swiper-pagination-1',
            },
            
            // 如果需要前进后退按钮
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            
            // 如果需要滚动条
            // scrollbar: {
            //     el: '.swiper-scrollbar',
            // },
        }) 
        mySwiper1.slideTo(this.currentImageKey + 1)
        this.init()
    },
    methods: {
        init(){
            this.setVisit()
        },
        async setVisit(){
            let res = await this.$api.rApi('user/visit', {
                type: 2,
                factory_id: this.product.factory_id,
                product_id: this.product.id,
                image: this.images.length > 0 ? this.images[0] : ''
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .product-show-box{
        position: fixed;
        width: 100%;
        height: 100vh;
        background: rgba(#000, 0.5);
        left: 0;
        top: 0;
        z-index: 99;
    }
    .product-box-main{
        width: 1400px;
        height: 780px;
        overflow: hidden;
        position: relative;
    }
    .swiper-button-prev{
        left: 100px;
        z-index: 99;
        &::after{
            content: '';
        }
        img{
            width: 52px;
            height: 52px;
        }
    }
    .swiper-button-next{
        right: 100px;
        z-index: 99;
        &::after{
            content: '';
        }
        img{
            width: 52px;
            height: 52px;
        }
    }
    .swiper-product{
        margin: 0 auto;
        width: 679px;
        height: 780px;
        overflow: hidden;
        .swiper-wrapper{
            .swiper-slide{
                .title{
                    text-align: center;
                    font-weight: bold;
                    font-size: 30px;
                    color: #FFFFFF;
                    text-align: center;
                    padding-bottom: 44px;
                }
                img{
                    width: 679px;
                    height: 679px;
                    border-radius: 10px;
                }
            }
        }
        .swiper-pagination-1{
            z-index: 99;
            position: absolute;
            left: 0;
            bottom: 100px;
        }
    }
    .close{
        position: absolute;
        right: 300px;
        top: 0;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/ProductDetail.vue